import {OnQueryStartedFunctionAttrType} from "@/types/generic/OnQueryStartedFunctionAttr.type";
import {
    UpdatePassengerGroupRequestType,
    UpdatePassengerGroupResponseType
} from "@CheckOrder/api/types/UpdatePassengerGroup.type";
import {
    setCheckOrderPassengers,
    setIsBuyingPremiumSupport,
    setIsBuyingSMSNotification,
    setPassengerDataUpdating,
    setTicket
} from "@CheckOrder/reducers/checkOrderSlice";
import updateArrayMember from "@Array/updateArrayMember";
import {setError} from "@Reducers/pageSlice";

export default function updatePassengerGroupQuery(): OnQueryStartedFunctionAttrType<UpdatePassengerGroupRequestType, UpdatePassengerGroupResponseType> {
    return async (request, {dispatch, queryFulfilled}) => {
        dispatch(setPassengerDataUpdating(true))

        try {
            const response = await queryFulfilled

            if (response.meta.response.ok && !!response.data?.data.success) {
                const newPassengerArray = updateArrayMember(
                    request.passengers,
                    request.passengerIndex,
                    'group',
                    response.data.data.passenger,
                    true
                )

                dispatch(setCheckOrderPassengers(newPassengerArray))
                dispatch(setTicket({ticket: response.data.data.ticket, keepPassengerClasses: true}))
                dispatch(setIsBuyingPremiumSupport(false))
                dispatch(setIsBuyingSMSNotification(false))

                dispatch(setPassengerDataUpdating(false))
            }
        } catch (err) {
            dispatch(setError({
                error: "Failed to update passenger group",
                info: `Failed to update ${JSON.stringify(request.passenger)}`,
            }))
            dispatch(setPassengerDataUpdating(false))
        }
    }
}